// extracted by mini-css-extract-plugin
module.exports = {"control":"Dropdown_control__6ZdhV","body":"Dropdown_body__7zmHo","notification":"Dropdown_notification__1vTCT","table":"Dropdown_table__1bFDh","input":"Dropdown_input__2A8lJ"};